// Unidades de progresso de leitura (Onda 3). Aditivo: 'pages' é o default.
// Os campos numéricos do livro (totalPages/currentPage/dailyGoal) guardam a
// contagem NA UNIDADE escolhida; só o rótulo muda por unidade.
export type ProgressUnit = 'pages' | 'chapters' | 'positions';

type UnitMeta = {
  unit: ProgressUnit;
  short: string;      // 'pág' | 'cap' | 'pos'
  long: string;       // 'páginas' | 'capítulos' | 'posições'
  capital: string;    // 'Páginas' | 'Capítulos' | 'Posições'
  one: string;        // 'página' | 'capítulo' | 'posição' (singular)
  where: string;      // 'página' (pra "Você parou na página/capítulo/posição")
  totalLabel: string; // 'Total de páginas/capítulos/posições'
  example: string;    // placeholder
  step: number;       // passo do slider/stepper
  goalMax: number;    // teto da meta diária
  defaultGoal: number; // meta diária padrão por unidade (fallback quando soma=0)
};

const META: Record<ProgressUnit, UnitMeta> = {
  pages:     { unit: 'pages',     short: 'pág', long: 'páginas',   capital: 'Páginas',   one: 'página',   where: 'página',   totalLabel: 'Total de páginas',   example: 'Ex: 312',  step: 1,  goalMax: 2000,  defaultGoal: 20 },
  chapters:  { unit: 'chapters',  short: 'cap', long: 'capítulos', capital: 'Capítulos', one: 'capítulo', where: 'capítulo', totalLabel: 'Total de capítulos', example: 'Ex: 24',   step: 1,  goalMax: 200,   defaultGoal: 2 },
  positions: { unit: 'positions', short: 'pos', long: 'posições',  capital: 'Posições',  one: 'posição',  where: 'posição',  totalLabel: 'Total de posições',  example: 'Ex: 4500', step: 10, goalMax: 50000, defaultGoal: 1000 },
};

export const unitMeta = (u?: string | null): UnitMeta => META[(u as ProgressUnit)] || META.pages;
export const UNIT_OPTIONS: { value: ProgressUnit; label: string }[] = [
  { value: 'pages', label: 'Páginas' },
  { value: 'chapters', label: 'Capítulos' },
  { value: 'positions', label: 'Posições' },
];
